export default "__VITE_ASSET__$OMIWu7c__"